import { FC, useContext, CSSProperties, useMemo, } from "react";
// 组件
import { MoreOutlined } from "@ant-design/icons";
import { ProDropdown, ProMenu, } from '../antd';
// 方法
import classNames from "classnames";
import { MenuItemProps, MenuTreeChildrenEnum } from "./interface";
import MenuTreeContext from "./menuTreeContext";
import { IBtnList } from "../ButtonGroup/buttonGroup";
import { CommonlyTypeEnum } from "../SuperTable/interface";
import { MenuProps } from "antd";

const MenuItem: FC<MenuItemProps> = props => {
  const {
    children, index, level, parentIndex, operation, icon, label, subLabel, className,
    titleTtooltip, style, collapsed, onClickOperation,
  } = props;
  const context = useContext(MenuTreeContext);
  const handleClick = () => {
    index !== undefined && context.onSelect?.(index, label || children, parentIndex);
  };
  /** 点击操作按钮 */
  const handleClickMenuItem = (item: any) => {
    onClickOperation?.(item.key, index as string, label || children, parentIndex);
  };
  const dropdownMenu: MenuProps | undefined = useMemo(() => {
    if (Array.isArray(operation) && operation.length) {
      const menuItems: MenuProps['items'] = [];
      operation.forEach(item => {
        const operationItem: IBtnList = (typeof item === 'object') ? item : CommonlyTypeEnum[item];
        menuItems.push({
          key: operationItem.key,
          icon: operationItem.icon,
          disabled: operationItem.disabled,
          danger: operationItem.danger,
          label: operationItem.label
        });
      });
      return {
        items: menuItems,
        onClick: handleClickMenuItem,
      };
    }
  }, [operation]);
  const titleStr = useMemo(() => {
    if (titleTtooltip) return titleTtooltip;
    if (titleTtooltip === false) return;
    const labelNode = label || children;
    if (labelNode && typeof labelNode === 'string') {
      if (subLabel && typeof subLabel === 'string') {
        return `${labelNode} ${subLabel}`;
      }
      return labelNode;
    }
  }, [label, children, subLabel, titleTtooltip]);
  const classes = useMemo(() => {
    return classNames('yb-menu-tree-menu-item', className, {
      'is-active': index === context.selectedKey,
    });
  }, [context.selectedKey]);
  const liStyle: CSSProperties = useMemo(() => {
    return {
      ...style,
      paddingLeft: `${level ? (10 + (24 * level)) : 10}px`,
    };
  }, [level, style]);
  return (
    <li
      className={classes}
      style={liStyle}
    >
      <div onClick={handleClick} className="menu-item-title yb-line-ellipsis ">
        <div className="menu-item-title-icon">{icon}</div>
        {
          !collapsed && (
            <div className="yb-line-ellipsis" title={titleStr}>
              <span>{label || children}</span>
              {!!subLabel && <span className="menu-item-title-sub">{subLabel}</span>}
            </div>
          )
        }
      </div>
      {
        !collapsed && dropdownMenu && (
          <div className="menu-item-operation">
            <ProDropdown menu={dropdownMenu} trigger={['click']}>
              <MoreOutlined className="menu-item-operation-icon" />
            </ProDropdown>
          </div>
        )
      }
    </li>
  );
};

MenuItem.displayName = MenuTreeChildrenEnum.MenuItem;

export default MenuItem;